<div class="viewport-layout-content" [hidden]="hasError">
    <ng-content select="[content]"></ng-content>
</div>
<div class="viewport-layout-error" [hidden]="!hasError">
    <ng-content select="[error]"></ng-content>
</div>
